
//内部工作系统
//基础框架
import mainFrame from '@/components/MainFrame.vue'
import opFrame from '@/components/OpFrame.vue'
import guestFrame from '@/components/GuestFrame.vue'

//主页
import indexContent from '@/components/Index/IndexContent.vue'

//注册及登录
import login from '@/components/Account/Login.vue'
import register from '@/components/Account/Register.vue'

//个人中心
import accountCenter from '@/components/Account/AccountCenter.vue'

//样品检测
// import projectReceive from '@/components/Inspection/Receive/ProjectReceive.vue'
import sampleReceive from '@/components/Inspection/Receive/SampleReceive.vue'
import taskReceive from '@/components/Inspection/Receive/TaskReceive.vue'
import subSampleDo from '@/components/Inspection/Task/SubSampleDo.vue'
import taskDo from '@/components/Inspection/Task/TaskDo.vue'
import taskStart from '@/components/Inspection/Task/TaskDo/TaskStart.vue'
import taskEnd from '@/components/Inspection/Task/TaskDo/TaskEnd.vue'
import taskAccept from '@/components/Inspection/Task/TaskDo/TaskAccept.vue'
import taskInfo from '@/components/Inspection/Task/TaskDo/TaskInfo.vue'
import taskAllot from '@/components/Inspection/Task/TaskDo/TaskAllot.vue'
import allotSuccess from '@/components/Inspection/Task/AllotSuccess.vue'
import myTask from '@/components/Inspection/Task/MyTask.vue'
import acceptableTask from '@/components/Inspection/Task/AcceptableTask.vue'
import originRecord from '@/components/Inspection/Task/OriginRecord.vue'
import originRecordOp from '@/components/Inspection/Task/OriginRecordOp.vue'

//业务管理
import completeCustomer from '@/components/Business/Order/CompleteCustomer.vue'
import reviewSuccess from '@/components/Business/Order/ReviewSuccess.vue'
import sampleCheck from '@/components/Business/Manage/SampleCheck.vue'


//委托单信息
import contractInfo from '@/components/Business/Order/ContractInfo.vue'

//报告
import reportView from '@/components/Report/ReportView.vue'
import reportVerify from '@/components/Report/ReportVerify.vue'
import reportApprove from '@/components/Report/ReportApprove.vue'
// import myReport from '@/components/Report/MyReport.vue'
import myReportWithRecord from '@/components/Report/MyReportWithRecord.vue'
import reportDistinguish from '@/components/Report/ReportDistinguish.vue'

//档案资料
import standardList from '@/components/Archive/StandardList.vue'
import materialList from '@/components/Archive/MaterialList.vue'
import raList from '@/components/Archive/RaList.vue'

//实验室管理
import dataPanel from '@/components/Manage/Data/Panel.vue'
import railway from '@/components/Manage/Data/Railway.vue'
import dayProjectList from '@/components/Manage/DayProjectList.vue'

//销售支持
import manufacturerData from '@/components/Sales/ManufacturerData.vue'
import supplierAnalysis from '@/components/Sales/SupplierAnalysis.vue'
import superProjectList from '@/components/Sales/SuperProjectList.vue'

//设备管理
import equipmentInfo from '@/components/Equipment/EquipmentInfo.vue'
import equipmentTestOp from '@/components/Equipment/EquipmentTestOp.vue'
import equipmentCalibrationRecord from '@/components/Equipment/EquipmentCalibrationRecord.vue'
import equipmentMaintainRecord from '@/components/Equipment/EquipmentMaintainRecord.vue'
import equipmentPeriodCheck from '@/components/Equipment/EquipmentPeriodCheck.vue'
import equipmentWorkInstruction from '@/components/Equipment/EquipmentWorkInstruction.vue'

//样品管理
import packageManage from '@/components/Sample/PackageManage.vue'
import packageOp from '@/components/Sample/PackageOp.vue'
import sampleInfo from '@/components/Sample/SampleInfo.vue'
import warehouseInfo from '@/components/Warehouse/WarehouseInfo.vue'

//检测意向
import rpManage from '@/components/Intention/RpManage.vue'
import wcManage from '@/components/Intention/WcManage.vue'

//业务管理
import contractView from '@/components/Business/Order/ContractView.vue'



/*import workFrame from '@/components/WorkFrame.vue'


//主页及登录
import systemLogin from '@/components/systemLogin.vue'
import systemRegister from '@/components/systemRegister.vue'
import myWork from '@/components/MyWork.vue'
import homeCarousel from '@/components/IndexContent/HomeCarousel.vue'
import indexContent from '@/components/IndexContent/IndexContent.vue'
import quickNav from '@/components/IndexContent/QuickNav.vue'


//样品检测
import sampleReceive from '@/components/Inspection/Receive/SampleReceive.vue'
import inspectionWork from '@/components/Inspection/Record/InspectionWork.vue'


//报告相关
import reportEdit from '@/components/Report/ReportEdit.vue'
import reportVerify from '@/components/Report/ReportVerify.vue'
import reportApprove from '@/components/Report/ReportApprove.vue'
import wreportQuery from '@/components/Report/ReportQuery.vue'
import myReport from '@/components/Report/MyReport.vue'
import reportPrint from '@/components/Report/ReportPrint.vue'

//业务管理
import orderWork from '@/components/Business/Order/OrderWork.vue'
import orderManage from '@/components/Business/Order/OrderManage.vue'
import productManage from '@/components/Business/Manage/ProductManage.vue'
import sampleManage from '@/components/Business/Manage/SampleManage.vue'
import deliveryManage from '@/components/Business/Delivery/DeliveryManage.vue'
import customerManage from '@/components/Business/Manage/CustomerManage.vue'


//资料档案
import raList from '@/components/Archive/RaList.vue'
import materialList from '@/components/Archive/MaterialList.vue'
import standardList from '@/components/Archive/StandardList.vue'
import standardManagement from '@/components/Archive/StandardManage.vue'
import matManage from '@/components/Archive/MatManage.vue'
import raManage from '@/components/Archive/RaManage.vue'

//实验室管理
import dataPanelAll from '@/components/Laboratory/Data/PanelAll.vue'
import equipmentManage from '@/components/Laboratory/Manage/EquipmentManage.vue'
import recordManage from '@/components/Laboratory/Manage/RecordManage.vue'
import staffManage from '@/components/Laboratory/Manage/StaffManage.vue'


//综合服务
import personalDelivery from '@/components/RearService/Delivery/PersonalDelivery.vue'
import download from '@/components/RearService/ResourceCenter/Download.vue'

//财务相关
import cashCheck from '@/components/Financial/CashCheck.vue'
import cashRecord from '@/components/Financial/CashRecord.vue'

//个人中心
import accountCenter from '@/components/Account/AccountCenter.vue'

//对象内容
import contractStat from '@/components/Content/ContractStat.vue'
import reportBrowse from '@/components/Content/ReportBrowse.vue'*/



export default [

    //内部工作系统
    //主页及登录等
    {
        path:"/",
        name:"main",
        component:mainFrame,
        children:[
            //主页及登录等
            {
            path:"/index",
            name:"index",
            components:{
                default:indexContent,
            },
            },
            {
                path:"/login",
                name:"login",
                component:login,
            },
            {
                path:"/register",
                name:"register",
                component:register,
            },
            {
                path:"/accountCenter",
                name:"accountCenter",
                component:accountCenter,
            },
        ] 
    },
    {
        path: "/intention",
        name: "intention",
        component: opFrame,
        children: [
            {
                path: "rpManage",
                name: "rpManage",
                components: {
                    default: rpManage,
                }
            },
            {
                path:"wcManage/:ifLink",
                name:"wcManage",
                components:{
                    default:wcManage,
                },
                props:{
                    default:true
                },
            },

        ]

    },
    {
        path:"",
        name:"op",
        component:opFrame,
        children:[
            //样品前台收取
            {
                path:"sampleManage",
                name:"sampleManage",
                component:sampleCheck,
            },
            //前台收快递等包裹管理
            {
                path:"packageManage",
                name:"packageManage",
                component:packageManage,
            },
            //样品检测接收
            {
                path:"taskReceive",
                name:"taskReceive",
                component:taskReceive,
            },
            {
                path:"sampleReceive/:project_display_no",
                name:"sampleReceive",
                components:{
                    default:sampleReceive,
                },
                props:{
                    default:true
                },
            },
            {
                path:"s_i/:project_display_no",
                name:"s_i",
                components:{
                    default:contractInfo,
                },
                props:{
                    default:true
                },
            },
            //我的任务
            {
                path:"su_i/:sub_sample_display_no",
                name:"su_i",
                components:{
                    default:subSampleDo,
                },
                props:{
                    default:true
                },
            },
            //任务界面及扫码界面
            {
                path:"task/:enid",
                name:"task",
                components:{
                    default:taskDo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"taskAccept/:enid",
                name:"taskAccept",
                components:{
                    default:taskAccept,
                },
                props:{
                    default:true
                },
            },
            {
                path:"taskEnd/:enid",
                name:"taskEnd",
                components:{
                    default:taskEnd,
                },
                props:{
                    default:true
                },
            },
            {
                path:"taskStart/:enid",
                name:"taskStart",
                components:{
                    default:taskStart,
                },
                props:{
                    default:true
                },
            },
            {
                path:"taskAllot/:enid",
                name:"taskAllot",
                components:{
                    default:taskAllot,
                },
                props:{
                    default:true
                },
            },
            {
                path:"taskInfo/:enid",
                name:"taskInfo",
                components:{
                    default:taskInfo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"sampleInfo/:enid",
                name:"sampleInfo",
                components:{
                    default:sampleInfo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"wh/:enid",
                name:"warehouseInfo",
                components:{
                    default:warehouseInfo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"packageOp/:enid",
                name:"packageOp",
                components:{
                    default:packageOp,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipment/:enid",
                name:"equipmentInfo",
                components:{
                    default:equipmentInfo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipmentTestOp/:enid",
                name:"equipmentTestOp",
                components:{
                    default:equipmentTestOp,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipmentCalibrationRecord/:enid",
                name:"equipmentCalibrationRecord",
                components:{
                    default:equipmentCalibrationRecord,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipmentMaintainRecord/:enid",
                name:"equipmentMaintainRecord",
                components:{
                    default:equipmentMaintainRecord,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipmentPeriodCheck/:enid",
                name:"equipmentPeriodCheck",
                components:{
                    default:equipmentPeriodCheck,
                },
                props:{
                    default:true
                },
            },
            {
                path:"equipmentWorkInstruction/:enid",
                name:"equipmentWorkInstruction",
                components:{
                    default:equipmentWorkInstruction,
                },
                props:{
                    default:true
                },
            },
            //样品扫码界面
            {
                path:"sample/:enname",
                name:"sample",
                components:{
                    default:subSampleDo,
                },
                props:{
                    default:true
                },
            },
            {
                path:"allot_success",
                name:"allot_success",
                component:allotSuccess,
                props:true
            },
            //可接受任务列表
            {
                path:"acceptableTask",
                name:"acceptableTask",
                component:acceptableTask,
            },
            //包含待检列表
            {
                path:"myTask",
                name:"myTask",
                component:myTask,
            },
            //原始记录列表
            {
                path:"originRecord",
                name:"originRecord",
                component:originRecord,
            },
            //原始记录详情及操作
            {
                path:"originRecordOp/:pid",
                name:"originRecordOp",
                components:{
                    default:originRecordOp,
                },
                props:{
                    default:true
                },
            },
            //委托信息查询 
            {
                path:"contract_stat/:project_display_no",
                name:"contract_stat",
                component:contractInfo,
                props:true
            },
            //报告查询审核等
            {
                path:"wreportQuery/:report_display_no",
                name:"wreportQuery",
                component:reportView,
                props:true
            },
            {
                path:"reportVerify",
                name:"reportVerify",
                component:reportVerify,
            },
            {
                path:"reportApprove",
                name:"reportApprove",
                component:reportApprove,
            },
            // {
            //     path:"myReport",
            //     name:"myReport",
            //     components:{
            //         default:myReport,
            //     }
            // },
            {
                path:"myReport",
                name:"myReport",
                components:{
                    default:myReportWithRecord,
                }
            },
            //资料档案管理
            {
                path:"ra_l",
                name:"ra_l",
                component:raList,
            },
            {
                path:"mat_l",
                name:"mat_l",
                component:materialList,
            },
            {
                path:"standard_l",
                name:"standard_l",
                component:standardList,
            },
            //实验室管理
            {
                path:"dataPanel",
                name:"dataPanel",
                component:dataPanel,
            },
            {
                path:"railway",
                name:"railway",
                component:railway,
            },
            {
                path:"dayProjectList/:dayDelta",
                name:"dayProjectList",
                component:dayProjectList,
                props:true
            },
            //销售支持
            {
                path:"superProjectList",
                name:"superProjectList",
                component:superProjectList,
            },
            {
                path:"manufacturerData",
                name:"manufacturerData",
                component:manufacturerData,
            },
            {
                path:"supplierAnalysis",
                name:"supplierAnalysis",
                component:supplierAnalysis,
            },
        ] 
    },
    {
        path:"",
        name:"guest",
        component:guestFrame,
        children:[
            //客户信息更新
            {
                path:"c_r/:project_enid",
                name:"c_r",
                component:completeCustomer,
                props:true
            },
            {
                path:"review_success",
                name:"review_success",
                component:reviewSuccess,
                props:true
            },
            //报告鉴别真伪
            {
                path:"d_r/:report_enid",
                name:"d_r",
                component:reportDistinguish,
                props:true
            }
        ] 
    }, 
    {
        path:"",
        name:"sales",
        component:opFrame,
        children:[
            //销售签发
            {
                path:"s_r/:project_enid",
                name:"s_r",
                component:contractView,
                props:true
            },
        ] 
    },
   
/*
    //样品检测
    {
        path:"/inspection",
        name:"inspection",
        component:workFrame,
        children:[
            {
                path:"sampleReceive",
                name:"sampleReceive",
                components:{
                    default:sampleReceive,
                }
            },
            {
                path:"inspectionWork",
                name:"inspectionWork",
                components:{
                    default:inspectionWork,
                }
            },  

        ],
    },

    //报告相关
    {
        path:"/report",
        name:"report",
        component:workFrame,
        children:[
            {
                path:"reportEdit/:reportNo",
                name:"reportEdit",
                components:{
                    default:reportEdit,
                },
                props:{
                    default:true
                },
            },
            {
                path:"reportEditS",
                name:"reportEditS",
                components:{
                    default:reportEdit,
                },
            },  
            {
                path:"reportVerify",
                name:"reportVerify",
                components:{
                    default:reportVerify,
                }
            }, 
            {
                path:"reportApprove",
                name:"reportApprove",
                components:{
                    default:reportApprove,
                }
            },
            {
                path:"wreportQuery",
                name:"wreportQuery",
                components:{
                    default:wreportQuery,
                }
            },
             
            {
                path:"myReport",
                name:"myReport",
                components:{
                    default:myReport,
                }
            },
            {
                path:"reportPrint",
                name:"reportPrint",
                components:{
                    default:reportPrint,
                }
            },
        ]
    },

    //业务管理
    {
        path:"/business",
        name:"business",
        component:workFrame,
        children:[
            {
                path:"orderWork",
                name:"orderWork",
                components:{
                    default:orderWork,
                },
            },
            {
                path:"orderWorkCorrect/:contractNo",
                name:"orderWorkCorrect",
                components:{
                    default:orderWork,
                },
                props:{
                    default:true
                },
            },
            {
                path:"orderManage",
                name:"orderManage",
                components:{
                    default:orderManage,
                }
            },
            {
                path:"contractView/:contract_no",
                name:"contractView",
                components:{
                    default:contractView,
                },
                props:{
                    default:true
                },
            }, 
            {
                path:"productManage",
                name:"productManage",
                components:{
                    default:productManage,
                }
            },
            {
                path:"sampleManage",
                name:"sampleManage",
                components:{
                    default:sampleManage,
                }
            },
            {
                path:"deliveryManage",
                name:"deliveryManage",
                components:{
                    default:deliveryManage,
                }
            },
            {
                path:"customerManage",
                name:"customerManage",
                components:{
                    default:customerManage,
                }
            },
        ]
    },

    //资料档案
    {        
        path:'/archive',
        name:'archive',
        component:innerFrame,
        children:[
            {
                path:"ra_l",
                name:"ra_l",
                component:raList,
            },
            {
                path:"mat_l",
                name:"mat_l",
                component:materialList,
            },
            {
                path:"standard_l",
                name:"standard_l",
                component:standardList,
            },       
        ]
    },
    {        
        path:'/archive_m',
        name:'archive_m',
        component:workFrame,
        children:[
            {
                path:"standardManage",
                name:"standardManage",
                components:{
                    default:standardManagement,
                    
                }
            },
            {
                path:"matManage",
                name:"matManage",
                components:{
                    default:matManage,
                    
                }
            },
            {
                path:"raManage",
                name:"raManage",
                components:{
                    default:raManage,
                    
                }
            },        
        ]
    },

    //实验室管理
    {
        path:"/laboratory",
        name:"laboratory",
        component:workFrame,
        children:[
            {
                path:"equipmentManage",
                name:"equipmentManage",
                components:{
                    default:equipmentManage,
                }
            },
            {
                path:"recordManage",
                name:"recordManage",
                components:{
                    default:recordManage,
                }
            },
            {
                path:"staffManage",
                name:"staffManage",
                components:{
                    default:staffManage,
                }
            },
            {
                path:"all",
                name:"dataPanelAll",
                components:{
                    default:dataPanelAll,
                    
                }
            }, 
        ]

    },

    //综合服务
    {
        path:"/rearService",
        name:"rearService",
        component:workFrame,
        children:[            
            {
                path:"personalDelivery",
                name:"personalDelivery",
                components:{
                    default:personalDelivery,
                }
            },    
        ]
    },
    {
        path:"/rearService_i",
        name:"rearService_i",
        component:innerFrame,
        children:[
            {
                path:'download',
                name:'download',
                components:{
                    default:download,
                }
            },     
        ]
    },

    //财务相关
    {
        path:"/finacial",
        name:"finacial",
        component:workFrame,
        children:[
            {
                path:"cashCheck",
                name:"cashCheck",
                components:{
                    default:cashCheck,
                }
            },  
            {
                path:"cashRecord",
                name:"cashRecord",
                components:{
                    default:cashRecord,
                }
            },          
        ]

    },

    //个人中心
    {
        path:"/account",
        name:"account",
        component:innerFrame,
        children:[
            {
                path:'accountCenter',
                name:'accountCenter',
                component:accountCenter,
            },            
        ]
    },

    //对象内容
    {
        path:"/details",
        name:"details",
        component:innerFrame,
        children:[
            {
                path:"contract_stat/:project_display_no",
                name:"contract_stat",
                component:contractStat,
                props:true
            }, 
            {
                path:"report_browse/:report_display_no",
                name:"report_browse",
                component:reportBrowse,
                props:true
            },           
        ]
    },


    //待删除  
    */  
    
]